"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var JourneyTypes_1 = require("../../../../common/enum/JourneyTypes");
var useDealStatusAssertion_1 = require("../../common/react/useDealStatusAssertion");
var ConfirmationContinueInDealerScreen_1 = require("./continueInDealership/ConfirmationContinueInDealerScreen");
var useDataLayerOnConfirmation_1 = require("../../common/react/useDataLayerOnConfirmation");
var useScrollToTop_1 = require("../../../../common/hooks/navigation/useScrollToTop");
var ContinueInDealerConfirmationScreen = function () {
    var _a;
    useDealStatusAssertion_1.default((_a = {},
        _a[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = false,
        _a[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = 8100,
        _a[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _a));
    useDataLayerOnConfirmation_1.default('dealerConfirmation');
    useScrollToTop_1.default();
    return <ConfirmationContinueInDealerScreen_1.default />;
};
exports.default = ContinueInDealerConfirmationScreen;
